import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/product-forest-river-rv")({
  component: () => <Outlet />,
});
